module.exports = __webpack_public_path__ + "img/right-label.572da680.png";